// commissions.component.ts

import { Component, Inject, OnInit } from "@angular/core";
import { ExcelService } from "src/app/services/Excel.service";
import { ReportingService } from "./reporting.service";
import { CommissionReport } from "./reporting.models";
import { StoreService } from "src/app/services/store.service";

@Component({
  selector: "app-commissions",
  templateUrl: "./commissions.component.html",
  styleUrls: ["./commissions.component.css"],
})
export class CommissionsComponent2 implements OnInit {
  msgs = [];
  displaychargement = false;

  listAnnee = [];
  listMois = [];
  selectedAnnee: string = null;
  selectedMois: string = null;

  distributors = [];
  selectedDistributor: string = null;
  isUserPartenaire = false;
  currentDistributorMsisdn: string = null;
  currentDistributorName: string = null;

  epin: any[] = [];
  omy: any[] = [];

  // Raw report data
  reportData: CommissionReport = null;

  // EPIN KPIs
  totalEpinSold = 0;
  epinTarget = 0;
  epinPercent = 0;
  epinBonusHT = 0;
  epinBonusTTC = 0;

  // CONSO KPIs
  totalConso = 0;
  totalConsoBonus = 0;

  // Charts
  chartEpin: any = {
    labels: [],
    datasets: [],
  };
  chartConso: any = {
    labels: [],
    datasets: [],
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  constructor(
    @Inject(ReportingService) private api: ReportingService,
    private excel: ExcelService,
    private store: StoreService
  ) {}

  ngOnInit() {
    this.isUserPartenaire = this.store.isUserPartenaire;
    this.initDropdowns();
    this.loadDistributors();

    // Set default to current year and month
    const now = new Date();
    this.selectedAnnee = now.getFullYear().toString();
    this.selectedMois = (now.getMonth() + 1).toString().padStart(2, "0");
  }

  initDropdowns() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 10; i <= currentYear; i++) {
      this.listAnnee.push({ label: i.toString(), value: i.toString() });
    }

    const months = [
      { label: "Janvier", value: "01" },
      { label: "Février", value: "02" },
      { label: "Mars", value: "03" },
      { label: "Avril", value: "04" },
      { label: "Mai", value: "05" },
      { label: "Juin", value: "06" },
      { label: "Juillet", value: "07" },
      { label: "Août", value: "08" },
      { label: "Septembre", value: "09" },
      { label: "Octobre", value: "10" },
      { label: "Novembre", value: "11" },
      { label: "Décembre", value: "12" },
    ];

    this.listMois = [...months];
  }

  loadDistributors() {
    this.api.getDistributors().subscribe((r) => {
      if (this.isUserPartenaire) {
        const currentDistributor = r.find((d) => d.login === this.store.currentNomPDG);
        const distributor = currentDistributor || {
          login: this.store.currentNomPDG,
          msisdn: this.store.currentNomPDG,
        };

        this.currentDistributorMsisdn = distributor.msisdn;
        this.currentDistributorName = distributor.login;
        this.selectedDistributor = this.currentDistributorMsisdn;
        this.distributors = [
          { label: this.currentDistributorName, value: this.currentDistributorMsisdn },
        ];
        return;
      }

      this.distributors = r.map((d) => ({ label: d.login, value: d.msisdn }));
    });
  }

  async rechercher() {
    // Validation
    if (!this.selectedDistributor) {
      this.msgs = [
        {
          severity: "error",
          summary: "Erreur",
          detail: "Sélectionnez un distributeur",
        },
      ];
      return;
    }
    if (!this.selectedAnnee || !this.selectedMois) {
      this.msgs = [
        {
          severity: "error",
          summary: "Erreur",
          detail: "Sélectionnez année et mois",
        },
      ];
      return;
    }

    this.displaychargement = true;
    this.msgs = [];

    try {
      const period = this.selectedAnnee + this.selectedMois;

      // Resolve distributor name (login / nom_pdg) from dropdown options so we can
      // send both MSISDN (for EPIN API) and name (for OMY API) to the backend.
      const distOption =
        this.distributors.find((d) => d.value === this.selectedDistributor) ||
        null;
      const distributorMsisdn = this.isUserPartenaire
        ? this.currentDistributorMsisdn
        : this.selectedDistributor;
      const distributorName = this.isUserPartenaire
        ? this.currentDistributorName
        : distOption ? distOption.label : null;

      // Get data using NEW method
      this.reportData = await this.api
        .getCommissionReport(distributorMsisdn, period, distributorName)
        .toPromise();

      console.log("📊 Report Data:", this.reportData);

      // Convert to old format for compatibility
      this.epin = this.convertEpinCards(this.reportData.epinCards);
      this.omy = this.convertConsoCards(this.reportData.consumptionCards);

      // Compute KPIs
      this.computeEpin();
      this.computeConso();
      this.initCharts();

      this.msgs = [
        {
          severity: "success",
          summary: "Succès",
          detail: `Données chargées: ${this.epin.length} EPIN, ${this.omy.length} Conso`,
        },
      ];
    } catch (e) {
      console.error("❌ Error:", e);
      this.msgs = [
        {
          severity: "error",
          summary: "Erreur",
          detail: "Impossible de charger les données",
        },
      ];
    }

    this.displaychargement = false;
  }

  // ═══════════════════════════════════════════════════════
  // CONVERSION HELPERS
  // ═══════════════════════════════════════════════════════

  convertEpinCards(cards: any[]): any[] {
    return cards.map((card) => ({
      msisdn: card.msisdn,
      month: card.month,
      montant_realise: card.actualPurchase,
      total_objectif_o2c: card.target,
      percentage: card.achievementRate,
      bonus_ttc: card.commission !== undefined ? parseFloat(card.commission.toFixed(0)) : 0,
      bonus_ht: card.commissionHT !== undefined ? parseFloat(card.commissionHT.toFixed(0)) : 0,
    }));
  }

  convertConsoCards(cards: any[]): any[] {
    return cards.map((card) => ({
      msisdn: card.msisdn,
      month: card.month || (card.activationDate ? card.activationDate.substring(0, 6) : ""),
      rev_m0: card.revenueM0,
      rev_m1: card.revenueM1,
      rev_m2: card.revenueM2,
      sharing: card.commission,
      bonus: card.commission,
    }));
  }

  // ═══════════════════════════════════════════════════════
  // KPI CALCULATIONS
  // ═══════════════════════════════════════════════════════

  computeEpin() {
    this.totalEpinSold = this.epin.reduce(
      (sum, x) => sum + (x.montant_realise || 0),
      0
    );
    this.epinTarget = this.epin.reduce(
      (sum, x) => sum + (x.total_objectif_o2c || 0),
      0
    );
    this.epinPercent =
      this.epinTarget > 0 ? (this.totalEpinSold * 100) / this.epinTarget : 0;
    this.epinBonusHT = this.epin.reduce((sum, x) => sum + (x.bonus_ht || 0), 0);
    this.epinBonusTTC = this.epin.reduce((sum, x) => sum + (x.bonus_ttc || 0), 0);

    console.log("📈 EPIN KPIs:", {
      sold: this.totalEpinSold,
      target: this.epinTarget,
      percent: this.epinPercent,
      bonus_ht: this.epinBonusHT,
      bonus_ttc: this.epinBonusTTC,
    });
  }

  computeConso() {
    this.totalConso = this.omy.reduce(
      (sum, x) => sum + (x.rev_m0 || 0) + (x.rev_m1 || 0) + (x.rev_m2 || 0),
      0
    );
    this.totalConsoBonus = this.omy.reduce((sum, x) => sum + (x.bonus || 0), 0);

    console.log("📊 Conso KPIs:", {
      total: this.totalConso,
      bonus: this.totalConsoBonus,
    });
  }

  // ═══════════════════════════════════════════════════════
  // CHARTS
  // ═══════════════════════════════════════════════════════

  initCharts() {
    // EPIN Pie Chart
    this.chartEpin = {
      labels: ["Réalisé", "Restant"],
      datasets: [
        {
          data: [
            this.totalEpinSold,
            Math.max(0, this.epinTarget - this.totalEpinSold),
          ],
          backgroundColor: ["#42A5F5", "#FFA726"],
          hoverBackgroundColor: ["#64B5F6", "#FFB74D"],
        },
      ],
    };

    // Conso Bar Chart
    const sumM0 = this.omy.reduce((s, x) => s + (x.rev_m0 || 0), 0);
    const sumM1 = this.omy.reduce((s, x) => s + (x.rev_m1 || 0), 0);
    const sumM2 = this.omy.reduce((s, x) => s + (x.rev_m2 || 0), 0);

    this.chartConso = {
      labels: ["Mois 0", "Mois 1", "Mois 2"],
      datasets: [
        {
          label: "Revenus HT",
          data: [sumM0, sumM1, sumM2],
          backgroundColor: ["#66BB6A", "#29B6F6", "#EF5350"],
        },
      ],
    };

    console.log("📊 Charts initialized");
  }

  // ═══════════════════════════════════════════════════════
  // EXPORT
  // ═══════════════════════════════════════════════════════

  exporter() {
    const listExport = [
      ...this.epin.map((x) => ({
        Type: "EPIN",
        MSISDN: x.msisdn,
        Mois: x.month,
        Montant: x.montant_realise,
        Objectif: x.total_objectif_o2c,
        Pourcentage: x.percentage,
        Bonus: x.bonus_ttc,
      })),
      ...this.omy.map((x) => ({
        Type: "CONSO",
        MSISDN: x.msisdn,
        Mois: x.month,
        "Revenu M0 HT": x.rev_m0,
        "Revenu M1 HT": x.rev_m1,
        "Revenu M2 HT": x.rev_m2,
        "Sharing (10 %)": x.bonus,
      })),
    ];

    this.excel.exportAsExcelFile(listExport, "COMMISSIONS");
    this.msgs = [
      { severity: "info", summary: "Export", detail: "Fichier généré" },
    ];
  }
}
